import { NavLink } from 'react-router';
import { useMe } from '../session/SessionProvider';
import { agendaTabs } from './nav';

/** Pestañas de la Agenda: Calendario, Eventos, Reuniones, Clases y Cultos en un solo lugar. */
export function AgendaTabs() {
  const tabs = agendaTabs(useMe());
  if (tabs.length < 2) return null;
  return (
    <nav className="tabs tabs--scroll agenda-tabs" aria-label="Agenda">
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} className={({ isActive }) => `tabs__tab${isActive ? ' tabs__tab--active' : ''}`}>
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
